<template>
	<div class="m-rainbow-range-value-box" v-bind:style="computedStyles">
		<!-- @vue-expect-error -->
		{{ this.value }}
	</div>
</template>

<script>
import { percentOfValueInRange } from "../../utils";

export default {
	props: {
		min: Number,
		max: Number,
		value: Number,
		backgroundColors: {
			type: Array,
			default: function () {
				return [
					"#BB0000",
					"#BB2900",
					"#BB5300",
					"#BB7C00",
					"#BBA600",
					"#A6BB00",
					"#7CBB00",
					"#53BB00",
					"#29BB00",
					"#00BB00",
				];
			},
		},
	},
	computed: {
		computedStyles() {
			const percentOfRange = percentOfValueInRange(
				this.value,
				this.min,
				this.max,
			);
			const colorIndex = Math.round(
				(percentOfRange * (this.backgroundColors.length - 1)) / 100,
			);
			return { backgroundColor: this.backgroundColors[colorIndex] };
		},
	},
};
</script>
<style scoped>
.m-rainbow-range-value-box {
	color: #fff;
	display: inline-block;
	font-weight: bold;
	font-size: 0.9em;
	width: 30px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	border-radius: 2px;
	margin-left: 10px;
}
</style>
